export default __webpack_public_path__ + "static/reactpainel-pt-b3a6c77ab59eea5986c6d97c3894cef9.png";